/* eslint-disable react/no-unescaped-entities */

import { Meta } from '@/layout/Meta'
import { Main } from '@/templates/Main'
import { AppConfig } from '@/utils/AppConfig'
import { useEffect } from 'react'
import { note } from '@/utils/Note'
import { useRouter } from 'next/router';

const FeatureRequests = () => {
  const router = useRouter()

  useEffect(() => {
    note('Visited Feature Request')
  }, [])

  return (
    <Main meta={<Meta 
        title="Cheap Custom Integrations - Dessert Data"
        description="We love building integrations at Dessert Data, let us know what you're hungry for" />}>
      <section className="mt-10 flex items-center">
        <img 
          alt="Digital Ice Cream"
          src={`${router.basePath}/assets/images/heros/digital-icecream2.jpeg`} 
          className="hidden md:block rounded-3xl h-64 mx-auto my-10 md:m-5"
        />
        <div>
          <h2 className="text-2xl font-bold text-sky-700 mt-5">Contact Us</h2>
          <p className="text-sm">
            Need something else integrated before (or after) you sign up? Email us at <a href={ AppConfig.email }>
            { AppConfig.email }</a>.  We'll get it built for you in as little as 
            <strong> 1-2 days</strong>.  And for as little a <strong>free!</strong>
          </p>
          <p className="text-sm">
            We are watching our inbox for your email 🤩!
          </p>
        </div>
      </section>
    </Main>
  )
}

export default FeatureRequests
